import { createAction, props } from '@ngrx/store';
import { ISummaryData, ISummaryModel } from '@partners/api';

export class SummaryActions {
  static reset = createAction('[Summary] Reset State');
  static sendAuthLink = createAction('[Summary] Send Auth Link');
  static load = createAction('[Summary] Load');
  static loadSuccess = createAction('[Summary] Load Success', props<{ model: ISummaryModel; data: ISummaryData }>());
  static loadFailure = createAction('[Summary] Load Failure', props<{ error: any }>());
  static submit = createAction('[Summary] Submit', props<{ model: ISummaryModel }>());
  static submitSuccess = createAction('[Summary] Submit Success', props<{ data: ISummaryData }>());
  static submitFailure = createAction('[Summary] Submit Failure', props<{ error: any }>());
}
